var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpConv2Dtranspose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.458333 26.458334",
    height: 30,
    width: 30,
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44811",
    transform: "translate(0,0.02451585)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "39.3837px",
      lineHeight: 1.25,
      fontFamily: "'Linux Libertine'",
      InkscapeFontSpecification: "'Linux Libertine'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.366658
    },
    transform: "matrix(2.0356822,0,0,2.0356822,-15.734388,-10.793724)",
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12.575336,13.457926 q -0.673061,-0.153842 -1.653808,-0.153842 -3.1922333,0 -3.1922333,-1.461505 0,-0.480758 0.3076851,-0.826904 0.3269155,-0.365376 0.9999768,-0.365376 0.7499826,0 1.9038024,0.865364 1.153819,0.865365 1.865341,1.15382 -0.07692,-0.788443 -0.499988,-1.942263 -0.403837,-1.1730495 -0.403837,-1.6922682 0,-0.6346006 0.326915,-1.0768981 0.346146,-0.4615277 0.865365,-0.4615277 1.307662,0 1.288431,1.3845832 0,0.5576794 -0.365376,1.9230328 -0.346146,1.346122 -0.384606,1.903802 0.749982,-0.307686 1.884571,-1.17305 1.15382,-0.884595 1.865342,-0.884595 0.711522,0 1.019207,0.403837 0.326915,0.384606 0.326915,0.788443 0,1.461505 -2.730705,1.461505 -1.211511,0 -2.153797,0.153842 0.480758,0.519219 1.365353,1.134589 0.903825,0.59614 1.403814,1.096129 0.499988,0.480758 0.499988,1.19228 0,0.519218 -0.365376,0.826903 -0.346146,0.307686 -0.788443,0.307686 -0.673061,0 -1.134589,-0.615371 -0.442298,-0.6346 -0.903825,-1.78842 -0.442298,-1.173049 -0.749983,-1.692268 -0.269224,0.519219 -0.749983,1.749959 -0.480758,1.211511 -0.923055,1.78842 -0.423067,0.55768 -1.096128,0.55768 -0.5192192,0 -0.8269044,-0.326916 -0.3076851,-0.346146 -0.3076851,-0.769213 0,-0.749982 0.4999884,-1.249971 0.5192191,-0.519218 1.4230441,-1.076898 0.903825,-0.57691 1.384583,-1.134589 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "'Linux Libertine'",
      InkscapeFontSpecification: "'Linux Libertine'",
      fill: "#6a6a6a",
      fillOpacity: 1,
      strokeWidth: 0.366658
    },
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": -1,
    id: "text4422",
    style: {
      fontSize: "11.2238px",
      lineHeight: 1.25,
      fill: "#525252",
      strokeWidth: 0.701488
    },
    transform: "translate(-0.56339418,0.7966042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15.934804,3.8866836 h 3.441673 v 1.594788 h -3.441673 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'sans-serif Bold'"
    },
    id: "path44684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21.300087,6.4569776 h 1.863326 V 1.1684197 L 21.250764,1.5630064 V 0.12714918 l 1.901688,-0.39458671 h 2.005816 V 6.4569776 h 1.863326 v 1.4577787 h -5.721507 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'sans-serif Bold'"
    },
    id: "path44686"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpConv2Dtranspose);
export default __webpack_public_path__ + "static/media/op-conv2dtranspose.2efe85acc432d44142de3116b39db934.svg";
export { ForwardRef as ReactComponent };